import React, { useEffect, useState } from 'react'
import axiosInstance, { API_BASE } from '../apiconfig'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import Select from 'react-select'
import CommonFilter from '../components/CommonFilter'   // ✅ SHARED FILTER

const API = `${API_BASE}/api/interests`
const FARMERS_API = `${API_BASE}/api/farmers/GetFarmers`

export default function Interests() {

  const [farmers, setFarmers] = useState([])
  const [form, setForm] = useState({
    farmerId: 0,
    rate: 0,
    intMonth: '',
    forMonth: new Date().toISOString().slice(0, 10)
  })

  const [editing, setEditing] = useState(null)
  const [open, setOpen] = useState(false)

  const [filterFarmerId, setFilterFarmerId] = useState(0)
  const [monthYear, setMonthYear] = useState(
    new Date().toISOString().slice(0, 7)
  )

  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  })

  /* ================= FARMER OPTIONS ================= */
  const farmerOptions = farmers.map(f => ({
    value: f.id,
    label: `(${f.code}) ${f.firstName} ${f.lastName}`
  }))

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    { field: "id", headerName: "ID", width: 80 },

    {
      field: "farmerName",
      headerName: "Farmer",
      flex: 1,
      minWidth: 220,
      renderCell: (params) =>
        `(${params.row?.farmer?.code}) ${params.row?.farmer?.firstName || ""} ${params.row?.farmer?.lastName || ""}`
    },

    { field: "rate", headerName: "Rate", width: 120 },
    { field: "intMonth", headerName: "Interest Month", width: 140 },

    {
      field: "forMonth",
      headerName: "Date",
      width: 140,
      renderCell: (params) => {
        if (!params.value) return "";
        const d = new Date(params.value);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
      }
    },

    {
      field: "actions",
      type: "actions",
      width: 120,
      getActions: (params) => [
        <GridActionsCellItem
          key={`edit-${params.id}`}
          icon={<EditIcon />}
          label="Edit"
          onClick={() => startEdit(params.row)}
        />,
        <GridActionsCellItem
          key={`delete-${params.id}`}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => del(params.row.id)}
        />,
      ],
    },
  ]

  /* ================= EFFECTS ================= */
  useEffect(() => {
    fetchFarmers()
  }, [])

  useEffect(() => {
    fetchList()
  }, [paginationModel.page, paginationModel.pageSize, monthYear, filterFarmerId])

  /* ================= API ================= */
  const fetchFarmers = async () => {
    const r = await axiosInstance.get(FARMERS_API)
    setFarmers(r?.data ?? [])
  }

  const fetchList = async () => {
    setLoading(true)

    const res = await axiosInstance.get(API, {
      params: {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        dateTime: new Date(`${monthYear}-01`),
        filterFarmerId: filterFarmerId || 0
      },
    })

    setRows(res?.data?.data ?? [])
    setTotal(res?.data?.totalCount ?? 0)
    setLoading(false)
  }

  /* ================= FORM ================= */
  const submit = async (e) => {
    e.preventDefault()

    const payload = {
      ...form,
      rate: parseFloat(form.rate),
      forMonth: form.forMonth
    }

    if (editing) {
      await axiosInstance.put(`${API}/${editing}`, payload)
    } else {
      await axiosInstance.post(API, payload)
    }

    resetForm()
    fetchList()
  }

  const startEdit = (r) => {
    setEditing(r.id)
    setOpen(true)
    setForm({
      farmerId: r.farmerId,
      rate: r.rate,
      intMonth: r.intMonth,
      forMonth: r.forMonth
        ? r.forMonth.split('T')[0]
        : new Date().toISOString().slice(0, 10)
    })
  }

  const del = async (id) => {
    if (!confirm('You want to Delete?')) return
    await axiosInstance.delete(`${API}/${id}`)
    fetchList()
  }

  const resetForm = () => {
    setEditing(null)
    setForm({
      farmerId: 0,
      rate: 0,
      intMonth: '',
      forMonth: new Date().toISOString().slice(0, 10)
    })
  }

  /* ================= UI ================= */
  return (
    <div>

      {/* ================= ADD / EDIT ================= */}
      <div className="panel">
        <div className="panel-header" onClick={() => setOpen(!open)}>
          <h3>Add / Edit Interest</h3>
          <span className={open ? "rotate" : ""}>▼</span>
        </div>

        <div className={`collapse ${open ? "open" : ""}`}>
          <div className="panel-body">
            <form onSubmit={submit} className="form">

              <label>Farmer
                <Select
                  classNamePrefix="react-select"
                  placeholder="Search Farmer"
                  isClearable
                  isSearchable
                  options={farmerOptions}
                  value={farmerOptions.find(o => o.value === form.farmerId) || null}
                  onChange={(opt) =>
                    setForm({ ...form, farmerId: opt ? opt.value : 0 })
                  }
                />
              </label>

              <label>Rate
                <input
                  type="number"
                  value={form.rate}
                  onChange={e => setForm({ ...form, rate: e.target.value })}
                />
              </label>

              <label>Int. Month
                <input
                  value={form.intMonth}
                  type="number"
                  onChange={e => setForm({ ...form, intMonth: e.target.value })}
                />
              </label>

              <label>For Month
                <input
                  type="date"
                  value={form.forMonth}
                  onChange={e => setForm({ ...form, forMonth: e.target.value })}
                />
              </label>

              <div className="actions">
                <button type="submit">
                  {editing ? 'Update' : 'Create'}
                </button>
                {editing && (
                  <button type="button" onClick={resetForm}>
                    Cancel
                  </button>
                )}
              </div>

            </form>
          </div>
        </div>
      </div>

      {/* ================= SHARED FILTER ================= */}
      <CommonFilter
        loading={loading}
        filters={[
          {
            key: "farmer",
            type: "select",
            placeholder: "Search Farmer",
            options: farmerOptions,
            value: filterFarmerId,
            onChange: setFilterFarmerId,
          },
          {
            key: "month",
            type: "month",
            value: monthYear,
            onChange: setMonthYear,
          },
        ]}
        onClear={() => {
          setFilterFarmerId(0)
          setMonthYear(new Date().toISOString().slice(0, 7))
        }}
      />

      {/* ================= GRID ================= */}
      <div className="data">
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={total}
          loading={loading}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 50,100]}
          columnVisibilityModel={{ id: false }}

        />
      </div>

    </div>
  )
}
